<div class="about-container">
  <div class="container">
    <h1 [@slideInUp]="slideInUp">it 's what i stand for</h1>
    <div [@rubberBand]="rubberBand" class="about-flex">
      <div class="flex-item">
        <h2>About Me!</h2>
        <h4>Mr.Naresh Kumar</h4>
        <p>
          I will constantly strive for the perfection through updating
          skills need to perfect a job. I believe the signinicant part of
          a technician’s life is to spent some time on updating himself
          for the ever expanding technologies, So it’s my daily habit to
          make myself better than yesterday for making my situations
          more wonderful to contribute to a beautiful world.
        </p>
      </div>
    </div>
  </div>
</div>
